export default __webpack_public_path__ + "static/media/logo.3ca1eb57.svg";